export default "__VITE_ASSET__4988c1d2__"